import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookingReportState } from './booking-report.state';

export const selectBookingReportStore = createFeatureSelector<BookingReportState>('bookingReport');

export const selectBookingReportCalendarItems = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.calendarItems,
);

export const selectBookingReportCalendarFilters = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.calendarFilters,
);

export const selectBookingReportTableItems = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.tableItems,
);

export const selectBookingReportTableFilters = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.tableFilters,
);

export const selectBookingReportViewType = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.view,
);

export const selectBookingReportCalendarViewType = createSelector(
  selectBookingReportStore,
  (state: BookingReportState) => state.calendarViewType,
);
